// Persistência das projeções financeiras no Firestore (coleção compartilhada
// entre todos os usuários de backoffice). Os resultados mensais NÃO são salvos —
// são recalculados em memória pelo motor a partir de input/saidas. Salvamos apenas
// os parâmetros + alguns KPIs denormalizados para exibir na listagem.

import firebase from 'firebase/app'
import 'firebase/firestore'

const COLLECTION = 'projecoes'

function collection () {
  return firebase.firestore().collection(COLLECTION)
}

export function listProjecoes () {
  return collection().orderBy('lastUpdate', 'desc').get()
    .then(snapshot => snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })))
}

export function getProjecao (id) {
  return collection().doc(id).get()
    .then(doc => (doc.exists ? { id: doc.id, ...doc.data() } : null))
}

export function createProjecao (data) {
  const now = firebase.firestore.Timestamp.now()
  return collection().add({ ...data, createdAt: now, lastUpdate: now })
    .then(ref => ref.id)
}

export function updateProjecao (id, data) {
  const lastUpdate = firebase.firestore.Timestamp.now()
  return collection().doc(id).update({ ...data, lastUpdate })
}

export function removeProjecao (id) {
  return collection().doc(id).delete()
}
